// extracted by mini-css-extract-plugin
module.exports = {"BankBalancePage":"index_BankBalancePage__rbvZs","headerCon":"index_headerCon__skghu"};